module Meevo.Plugins.Register {
    "use strict";

    export class PaymentSection extends Meevo.Plugins.Register.RegisterSectionBase {
        paymentIcons: any;
        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.Payment, registerContext, "buttonSets", Register.RegisterSectionCatTypeEnum.Payment);
        }

        isTileVisible(paymentCat) {
            return !(paymentCat.sectionType === RegisterSectionTypeEnum.ClientPoints && !this.registerContext.hasRealClient());
        }

        isTileActive(paymentCat) {
            return this.registerContext.selectedSection.sectionType === paymentCat.sectionType;
        }

        isGiftCardPaymentAvailable(paymentCat) {
            return paymentCat.sectionType === RegisterSectionTypeEnum.GiftCardPayment && this.registerContext.sectionHasItems(paymentCat.sectionType);
        }
    }
}